module.exports = __webpack_public_path__ + "email_sent.20b2246128aea6aab05526782e9fc96b.svg";